import { NavLink as RouterNavLink, Link, useLocation } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarFooter,
} from "@/components/ui/sidebar";
import { useAuth } from "@/hooks/use-auth";
import {
  LayoutDashboard,
  Users,
  CreditCard,
  Wallet,
  Settings,
  Shield,
  Receipt,
} from "lucide-react";
import { Badge } from "@/components/ui/badge";

const adminMenuItems = [
  {
    title: "Dashboard",
    url: "/admin",
    icon: LayoutDashboard,
  },
  {
    title: "Usuários",
    url: "/admin/users",
    icon: Users,
  },
  {
    title: "Planos",
    url: "/admin/plans",
    icon: CreditCard,
  },
  {
    title: "Assinaturas",
    url: "/admin/subscriptions",
    icon: Receipt,
  },
  {
    title: "Pagamentos",
    url: "/admin/payments",
    icon: Wallet,
  },
  {
    title: "Documentação API",
    url: "/admin/api-docs",
    icon: Shield,
  },
];

const settingsItems = [
  {
    title: "Perfil",
    url: "/admin/profile",
    icon: Settings,
  },
];

export function AdminSidebar() {
  const location = useLocation();
  useAuth();

  const isActive = (path: string) => {
    if (path === "/admin") {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <Sidebar>
      <SidebarHeader className="border-b border-sidebar-border h-16 flex items-center justify-center">
        <div className="flex flex-col gap-2 px-2 items-center justify-center w-full">
          <Link to="/admin" className="flex items-center gap-2 justify-center">
            <img src="/devlovers-logo-light.png" alt="DevLovers" className="h-6 w-auto block dark:hidden" />
            <img src="/devlovers-logo-dark.png" alt="DevLovers" className="h-6 w-auto hidden dark:block" />
          </Link>
          <Badge className="w-fit text-xs bg-destructive">
            <Shield className="w-3 h-3 mr-1" />
            Admin
          </Badge>
        </div>
      </SidebarHeader>

      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Administração</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {adminMenuItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild isActive={isActive(item.url)}>
                    <RouterNavLink to={item.url}>
                      <item.icon className="h-4 w-4" />
                      <span>{item.title}</span>
                    </RouterNavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>

        <SidebarGroup>
          <SidebarGroupLabel>Configurações</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {settingsItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild isActive={isActive(item.url)}>
                    <RouterNavLink to={item.url}>
                      <item.icon className="h-4 w-4" />
                      <span>{item.title}</span>
                    </RouterNavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>

      <SidebarFooter className="border-t border-sidebar-border p-4">
        <div className="text-xs text-muted-foreground text-center font-medium">
          Membro DevLovers ❤️
        </div>
      </SidebarFooter>
    </Sidebar>
  );
}
